import Image from "../Media";
import UL from "../ListGroup/UnorderedList";
import LI from "../ListGroup/ListItem";
import IconComponent from "../IconComponent";

type ProductImageCardProps = {
  imageSrc: string;
  icon?: string;
  handleDownload?: any;
  containerClassname?: string;
  imageClassname?: string;
  altImage: string;
  key: any;
  isShowHover?: boolean;
};

const ProductImageCard = ({
  imageSrc,
  icon = "icon-import",
  handleDownload,
  containerClassname,
  imageClassname,
  altImage,
  key,
  isShowHover = false,
}: ProductImageCardProps) => {
  return (
    <div className="blog-box blog-grid text-center product-box">
      <div
        className={`product-img ${
          containerClassname ? containerClassname : "my-3"
        }`}
        key={key}
      >
        <Image
          className={`position-relative img-fluid b-r-2 ${
            imageClassname ? imageClassname : "w-100"
          } `}
          src={imageSrc}
          alt={altImage}
        />
        {isShowHover && (
          <div className="product-hover">
            <UL className="simple-list flex-row">
              <LI onClick={() => handleDownload(imageSrc, altImage)}>
                <IconComponent className={icon} />
              </LI>
            </UL>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductImageCard;
